import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  '@global': {
    '@keyframes pulse': {
      '0%, 100%': { opacity: 1 },
      '50%': { opacity: 0.3 }
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden'
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 'var(--padding-sm) var(--padding-md)',
    borderBottom: '1px solid var(--color-neutral-200)',
    flexShrink: 0
  },
  summary: {
    fontSize: 'var(--text-size-xs)',
    color: 'var(--color-neutral-500)',
    fontWeight: 500
  },
  toolbarActions: {
    display: 'flex',
    gap: 'var(--gap-xs)'
  },
  runMenuWrapper: {
    position: 'relative'
  },
  runMenu: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: '4px',
    backgroundColor: 'white',
    border: '1px solid var(--color-neutral-300)',
    borderRadius: 'var(--border-radius-sm)',
    boxShadow: 'var(--shadow-md)',
    zIndex: 100,
    overflow: 'hidden',
    minWidth: '170px'
  },
  menuItem: {
    display: 'block',
    width: '100%',
    padding: '8px 14px',
    border: 'none',
    backgroundColor: 'transparent',
    textAlign: 'left',
    fontSize: 'var(--text-size-sm)',
    color: 'var(--color-neutral-700)',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--color-neutral-050)'
    }
  },
  menuDivider: {
    height: '1px',
    backgroundColor: 'var(--color-neutral-200)',
    margin: '2px 0'
  },

  testList: {
    flexShrink: 0,
    maxHeight: '35%',
    overflow: 'auto'
  },
  testRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px var(--padding-md)',
    gap: 'var(--gap-sm)',
    cursor: 'pointer',
    borderBottom: '1px solid var(--color-neutral-100)',
    transition: 'background-color var(--transition-duration-short)',
    '&:hover': {
      backgroundColor: 'var(--color-neutral-050)'
    },
    '&:hover $rowActions': {
      opacity: 1
    }
  },
  testRowSelected: {
    backgroundColor: 'var(--color-primary-050)',
    '&:hover': {
      backgroundColor: 'var(--color-primary-050)'
    }
  },
  statusIndicator: {
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    flexShrink: 0
  },
  statusPassed: { backgroundColor: 'var(--color-success-500)' },
  statusFailed: { backgroundColor: 'var(--color-danger-500)' },
  statusNeutral: { backgroundColor: 'var(--color-neutral-400)' },
  modeBadge: {
    padding: '1px 6px',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: '10px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    flexShrink: 0
  },
  testName: {
    flex: 1,
    fontSize: 'var(--text-size-sm)',
    fontWeight: 500,
    color: 'var(--color-neutral-800)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0
  },
  testMeta: {
    fontSize: 'var(--text-size-xs)',
    color: 'var(--color-neutral-400)',
    flexShrink: 0
  },
  rowActions: {
    display: 'flex',
    gap: '2px',
    flexShrink: 0,
    opacity: 0
  },
  iconBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '22px',
    height: '22px',
    border: 'none',
    borderRadius: 'var(--border-radius-sm)',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    fontSize: '12px',
    color: 'var(--color-neutral-500)',
    '&:hover': {
      backgroundColor: 'var(--color-neutral-200)',
      color: 'var(--color-neutral-800)'
    }
  },
  iconBtnDanger: {
    '&:hover': {
      backgroundColor: 'var(--color-danger-050)',
      color: 'var(--color-danger-600)'
    }
  },

  detailArea: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
    borderTop: '2px solid var(--color-neutral-200)'
  },
  detailEmpty: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--color-neutral-400)',
    fontSize: 'var(--text-size-sm)',
    borderTop: '2px solid var(--color-neutral-200)'
  },
  detailHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px var(--padding-md)',
    borderBottom: '1px solid var(--color-neutral-200)',
    backgroundColor: 'var(--color-neutral-050)',
    flexShrink: 0
  },
  detailTitle: {
    fontSize: 'var(--text-size-sm)',
    fontWeight: 600,
    color: 'var(--color-neutral-700)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  detailTabs: {
    display: 'flex',
    borderBottom: '1px solid var(--color-neutral-200)',
    flexShrink: 0
  },
  detailTab: {
    padding: '6px 14px',
    fontSize: 'var(--text-size-xs)',
    fontWeight: 500,
    cursor: 'pointer',
    color: 'var(--color-neutral-500)',
    borderBottom: '2px solid transparent',
    '&:hover': {
      color: 'var(--color-neutral-800)'
    }
  },
  detailTabActive: {
    color: 'var(--color-primary-700)',
    borderBottomColor: 'var(--color-primary-500)',
    fontWeight: 600
  },
  detailContent: {
    flex: 1,
    overflow: 'auto',
    minHeight: 0
  },

  configPanel: {
    padding: 'var(--padding-md)',
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--gap-md)'
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  fieldRow: {
    display: 'flex',
    gap: 'var(--gap-md)',
    alignItems: 'center'
  },
  fieldLabel: {
    fontSize: 'var(--text-size-xs)',
    fontWeight: 'var(--text-weight-bold)',
    color: 'var(--color-neutral-500)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  nameInput: {
    padding: '6px 10px',
    height: '30px',
    boxSizing: 'border-box',
    border: '1px solid var(--color-neutral-300)',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: 'var(--text-size-sm)',
    outline: 'none',
    backgroundColor: 'white',
    '&:focus': {
      borderColor: 'var(--color-primary-400)',
      boxShadow: '0 0 0 2px var(--color-primary-100)'
    }
  },
  modeSelector: {
    display: 'flex',
    borderRadius: 'var(--border-radius-sm)',
    overflow: 'hidden',
    border: '1px solid var(--color-neutral-300)',
    alignSelf: 'flex-start'
  },
  modeOption: {
    padding: '4px 12px',
    fontSize: '11px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    backgroundColor: 'white',
    color: 'var(--color-neutral-500)',
    transition: 'all var(--transition-duration-short)',
    '&:not(:last-child)': {
      borderRight: '1px solid var(--color-neutral-300)'
    },
    '&:hover': {
      backgroundColor: 'var(--color-neutral-050)'
    }
  },
  aceWrapper: {
    border: '1px solid var(--color-neutral-200)',
    borderRadius: 'var(--border-radius-sm)',
    overflow: 'hidden'
  },

  outputPanel: {
    padding: 'var(--padding-sm) var(--padding-md)'
  },
  outputBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--gap-sm)',
    padding: '8px 12px',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: 'var(--text-size-sm)',
    fontWeight: 600,
    marginBottom: 'var(--margin-sm)'
  },
  bannerPass: {
    backgroundColor: 'var(--color-success-050)',
    color: 'var(--color-success-700)',
    border: '1px solid var(--color-success-200)'
  },
  bannerFail: {
    backgroundColor: 'var(--color-danger-050)',
    color: 'var(--color-danger-700)',
    border: '1px solid var(--color-danger-200)'
  },
  assertionError: {
    padding: '8px 12px',
    marginBottom: 'var(--margin-sm)',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: '12px',
    fontFamily: 'var(--font-mono)',
    color: 'var(--color-danger-700)',
    backgroundColor: 'var(--color-danger-050)',
    border: '1px solid var(--color-danger-200)',
    lineHeight: 1.5
  },
  resultWrapper: {
    position: 'relative'
  },
  resultPre: {
    margin: 0,
    padding: '10px 12px',
    fontSize: '12px',
    fontFamily: 'var(--font-mono)',
    whiteSpace: 'pre-wrap',
    color: 'var(--color-neutral-700)',
    lineHeight: 1.5,
    backgroundColor: 'var(--color-neutral-050)',
    borderRadius: 'var(--border-radius-sm)',
    border: '1px solid var(--color-neutral-200)',
    maxHeight: '300px',
    overflow: 'auto'
  },
  resultCopyBtn: {
    position: 'absolute',
    top: '6px',
    right: '6px',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid var(--color-neutral-200)',
    borderRadius: 'var(--border-radius-sm)',
    backgroundColor: 'white',
    cursor: 'pointer',
    fontSize: '12px',
    color: 'var(--color-neutral-400)',
    opacity: 0,
    transition: 'opacity 0.15s ease',
    '$resultWrapper:hover &': {
      opacity: 1
    },
    '&:hover': {
      color: 'var(--color-neutral-700)',
      backgroundColor: 'var(--color-neutral-050)'
    }
  },
  noOutput: {
    padding: 'var(--padding-lg)',
    textAlign: 'center',
    color: 'var(--color-neutral-400)',
    fontSize: 'var(--text-size-sm)'
  },
  requestRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--gap-sm)',
    padding: '6px 0',
    borderBottom: '1px solid var(--color-neutral-100)',
    fontSize: '12px',
    cursor: 'pointer',
    '&:last-child': { borderBottom: 'none' },
    '&:hover': {
      backgroundColor: 'var(--color-neutral-050)'
    }
  },
  methodBadge: {
    padding: '1px 5px',
    borderRadius: '3px',
    fontSize: '10px',
    fontWeight: 700,
    backgroundColor: 'var(--color-primary-050)',
    color: 'var(--color-primary-700)',
    fontFamily: 'var(--font-mono)',
    flexShrink: 0
  },
  requestUrl: {
    flex: 1,
    color: 'var(--color-neutral-800)',
    fontFamily: 'var(--font-mono)',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0
  },
  requestMeta: {
    display: 'flex',
    gap: 'var(--gap-sm)',
    flexShrink: 0,
    alignItems: 'center'
  },
  statusBadge: {
    fontSize: '10px',
    fontWeight: 600
  },
  mockedTag: {
    padding: '0 4px',
    borderRadius: '2px',
    fontSize: '10px',
    fontWeight: 600,
    backgroundColor: 'var(--color-primary-050)',
    color: 'var(--color-primary-600)'
  },

  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1200
  },
  modalContent: {
    width: '85vw',
    maxWidth: '1100px',
    height: '80vh',
    backgroundColor: 'white',
    borderRadius: 'var(--border-radius-lg)',
    border: '3px solid var(--color-neutral-300)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    boxShadow: 'var(--shadow-lg)'
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--gap-md)',
    padding: '12px 20px',
    borderBottom: '1px solid var(--color-neutral-200)',
    backgroundColor: 'var(--color-neutral-050)',
    flexShrink: 0
  },
  modalTitle: {
    flex: 1,
    fontFamily: 'var(--font-mono)',
    fontWeight: 600,
    fontSize: 'var(--text-size-sm)',
    color: 'var(--color-neutral-800)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  modalCloseBtn: {
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid var(--color-neutral-300)',
    borderRadius: 'var(--border-radius-sm)',
    backgroundColor: 'white',
    cursor: 'pointer',
    fontSize: '16px',
    color: 'var(--color-neutral-500)',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: 'var(--color-neutral-100)',
      color: 'var(--color-neutral-800)'
    }
  },
  modalBody: {
    flex: 1,
    display: 'flex',
    minHeight: 0,
    overflow: 'hidden'
  },
  modalPane: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    overflow: 'hidden',
    '&:first-child': {
      borderRight: '1px solid var(--color-neutral-200)'
    }
  },
  paneHeader: {
    padding: '8px 16px',
    fontSize: '11px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
    color: 'var(--color-neutral-500)',
    borderBottom: '1px solid var(--color-neutral-200)',
    backgroundColor: 'var(--color-neutral-050)',
    flexShrink: 0
  },
  panePre: {
    flex: 1,
    margin: 0,
    padding: '12px 16px',
    fontSize: '12px',
    fontFamily: 'var(--font-mono)',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
    color: 'var(--color-neutral-700)',
    lineHeight: 1.5,
    overflow: 'auto'
  },
  paneEmpty: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--color-neutral-400)',
    fontSize: 'var(--text-size-sm)',
    fontStyle: 'italic'
  },
  logRow: {
    display: 'flex',
    gap: 'var(--gap-sm)',
    padding: '3px 0',
    fontSize: '12px',
    fontFamily: 'var(--font-mono)'
  },
  logLevel: {
    minWidth: '38px',
    fontWeight: 600,
    flexShrink: 0
  },
  logMessage: {
    color: 'var(--color-neutral-700)',
    wordBreak: 'break-word'
  },
  outputTabBar: {
    display: 'flex',
    borderBottom: '1px solid var(--color-neutral-200)',
    flexShrink: 0
  }
}))
